@if (model.data.salesHandover && formGroup && formGroupContact) {
  <fui-rows [label]="'Sales Handover'" [formGroup]="formGroup">
    <fui-content-layout-header-control slot="after">
      @if (!editing && model.canEdit()) {
        <fui-link-button [title]="'edit'"
        (click)="edit()"></fui-link-button>
      }
    </fui-content-layout-header-control>
    @for (fieldTuple of fields; track fieldTuple) {
      <fui-row>
        <fui-two-columns>
          @for (field of fieldTuple; track field) {
            <fui-column>
              @if (field.type === 'date') {
                <fui-date-control
                  [formControlName]="field.name"
                  [control]="formGroup.get(field.name)"
                  [label]="field.name"
                  [placeholder]="'fhm.common.label.no-label'"
                  [disabled]="!editing"
                [(ngModel)]="field.value"></fui-date-control>
              }
              @if (field.type === 'checkbox') {
                <fui-checkbox-control
                  [formControlName]="field.name"
                  [control]="formGroup.get(field.name)"
                  [label]="field.name"
                  [placeholder]="'fhm.common.label.no-label'"
                  [disabled]="!editing"
                [(ngModel)]="field.value"></fui-checkbox-control>
              }
              @if (field.type === 'short_text') {
                <fui-text-control
                  [formControlName]="field.name"
                  [control]="formGroup.get(field.name)"
                  [label]="field.name"
                  [placeholder]="'fhm.common.label.no-label'"
                  [disabled]="!editing"
                [(ngModel)]="field.value"></fui-text-control>
              }
              @if (field.type === 'text') {
                <fui-textarea-control
                  [formControlName]="field.name"
                  [control]="formGroup.get(field.name)"
                  [label]="field.name"
                  [placeholder]="'fhm.common.label.no-label'"
                  [disabled]="!editing"
                [(ngModel)]="field.value"></fui-textarea-control>
              }
              @if (field.type === 'number') {
                <fui-numeric-control
                  [formControlName]="field.name"
                  [control]="formGroup.get(field.name)"
                  [label]="field.name"
                  [placeholder]="'fhm.common.label.no-label'"
                  [disabled]="!editing"
                [(ngModel)]="field.value"></fui-numeric-control>
              }
              @if (field.type === 'drop_down') {
                <fui-select-control
                  [disabled]="!editing"
                  [options]="field.typeConfig.options"
                  (valueChange)="changeDropDown(formGroup.get(field.name), field, $event)"
                  [labelField]="'name'"
                  [label]="field.name"
                  [placeholder]="' '"
                  [loading]="false"
                  [value]="getFieldOption(field)"
                  [control]="formGroup.get(field.name)"
                  [valueField]="'id'">
                </fui-select-control>
              }
            </fui-column>
          }
        </fui-two-columns>
      </fui-row>
    }
    <fui-rows [label]="'Site Contact'">
      <fui-row [formGroup]="formGroupContact">
        <fui-two-columns>
          <fui-column>
            <fui-text-control
              formControlName="firstName"
              [control]="formGroupContact.get('firstName')"
              [label]="'fhm.contact.firstName'"
              [placeholder]="'fhm.common.label.no-label'"
              [disabled]="!editing"
            [(ngModel)]="siteContact.firstName"></fui-text-control>
          </fui-column>
          <fui-column>
            <fui-text-control
              formControlName="lastName"
              [control]="formGroupContact.get('lastName')"
              [label]="'fhm.contact.lastName'"
              [placeholder]="'fhm.common.label.no-label'"
              [disabled]="!editing"
            [(ngModel)]="siteContact.lastName"></fui-text-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
      <fui-row [formGroup]="formGroupContact">
        <fui-two-columns>
          <fui-column>
            <fui-text-control
              formControlName="email"
              [control]="formGroupContact.get('email')"
              [label]="'fhm.contact.email'"
              [placeholder]="'fhm.common.label.no-label'"
              [disabled]="!editing"
            [(ngModel)]="siteContact.email"></fui-text-control>
          </fui-column>
          <fui-column>
            <fui-text-control
              [label]="'fhm.contact.mobile'"
              [placeholder]="'fhm.common.label.no-label'"
              [ngModelOptions]="{standalone: true}"
              [disabled]="!editing"
            [(ngModel)]="siteContact.mobile"></fui-text-control>
          </fui-column>
        </fui-two-columns>
      </fui-row>
    </fui-rows>
    @if (editing && !model.draft) {
      <fui-row>
        <fhm-action-buttons>
          <fhm-remove-button [title]="'fhm.common.button.cancel'"
          (clicked)="cancelEdit()"></fhm-remove-button>
          <fhm-provision-button [title]="'fhm.common.button.save'"
          (clicked)="save()"></fhm-provision-button>
        </fhm-action-buttons>
      </fui-row>
    }
  </fui-rows>
}
